import type { SanityImageObject } from '@sanity/image-url/lib/types/types';
import { isRecord } from 'sanity';

declare module '@sanity/image-url/lib/types/types' {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  interface SanityImageObject {
    metadata?: {
      lqip?: string;
      blurHash?: string;
    };
  }
}

export default function isSanityImageObject(
  image: string | unknown,
): image is SanityImageObject {
  return (
    isRecord(image) &&
    typeof image.asset !== 'undefined' &&
    (typeof image.hotspot === 'undefined' ||
      image.hotspot === null ||
      typeof image.hotspot === 'object')
  );
}
